import { createFileRoute } from '@tanstack/react-router'
import { MyProjectsPage } from '@/features/projects/pages/my-projects-page'

export const Route = createFileRoute('/_authenticated/_sidebar/grower/my-projects')({
  component: MyProjects,
})

function MyProjects() {
  return <MyProjectsPage />
}

